import { defineWave } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   INTERCEPTION — vitrine des INTERCEPTEURS.

   Une vague de démonstration pour les quatre archétypes rapides de cette passe :
   Lame (coupe la route horizontale), Escadrille (duo qui se croise), Chasseur
   (poste de tir mobile en rafale), Guêpe (feinte corporelle). Chacun est
   introduit SEUL puis laissé respirer, dans l'ordre de sa difficulté de lecture —
   la même discipline que le monde 1 impose à l'Éclat avant le Faucheur : une
   leçon donnée au milieu du bruit n'est pas une leçon.

   L'ordre monte du plus lisible au plus retors : une trajectoire droite (Lame),
   puis deux droites qui se coupent (Escadrille), puis une source de tir qui
   glisse (Chasseur), enfin une menace qui feinte et exige du sang-froid (Guêpe).

   Tous les intercepteurs sont légers (≤ 90 PV) : ils passent partout, couloirs de
   bord compris (la règle des 200 PV, vérifiée au chargement, ne les concerne
   pas). On les lance justement DEPUIS les bords pour la Lame et l'Escadrille, dont
   toute la leçon est le croisement au centre.

   ⚠️ Elle n'est volontairement câblée dans AUCUN niveau de la campagne. Le
   câblage d'un monde relève de l'équilibrage (courbe de puissance, respirations,
   silence d'avant-boss) et appartient au propriétaire du contenu de campagne, pas
   à l'ajout de ces archétypes. La vague existe pour prouver que la chaîne
   registre → levelSystem → pool → conduite/hook tient de bout en bout ; on la
   dépose dans un niveau le jour où l'on compose le monde qui les emploie.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineWave({
  id: 'interception',
  duration: 34,
  spawns: [
    // 1. Lame — la coupe droite, la plus lisible. `lame-a` file vers la droite,
    //    `lame-b` vers la gauche : lancées depuis les bords opposés, elles se
    //    coupent au centre et referment le couloir bas des deux côtés à la fois.
    //    Il faut changer d'axe et s'élever.
    { at: 0.5, enemy: 'lame-a', lane: 1, count: 1, spacing: 0 },
    { at: 0.7, enemy: 'lame-b', lane: 5, count: 1, spacing: 0 },

    // 2. Escadrille — le ciseau. `a` dérive à droite, `b` à gauche : on les pose
    //    sur les bords OPPOSÉS pour qu'ils se coupent au centre. Deux passages
    //    pour laisser voir la géométrie se répéter.
    { at: 6.0, enemy: 'escadrille-a', lane: 1, count: 1, spacing: 0 },
    { at: 6.0, enemy: 'escadrille-b', lane: 5, count: 1, spacing: 0 },
    { at: 9.5, enemy: 'escadrille-a', lane: 0, count: 1, spacing: 0 },
    { at: 9.5, enemy: 'escadrille-b', lane: 6, count: 1, spacing: 0 },

    // 3. Chasseur — la source de tir qui glisse. Deux postes, de part et d'autre,
    //    pour que le pistage doive composer avec deux arcs mobiles.
    { at: 15.0, enemy: 'chasseur', lane: 2, count: 1, spacing: 0 },
    { at: 15.6, enemy: 'chasseur', lane: 4, count: 1, spacing: 0 },

    // 4. Guêpe — la feinte. En dernier, car sa leçon n'est pas un geste mais du
    //    sang-froid. Deux, décalées, pour que le harcèlement se croise.
    { at: 22.0, enemy: 'guepe', lane: 3, count: 1, spacing: 0 },
    { at: 24.0, enemy: 'guepe', lane: 2, count: 1, spacing: 0 },
  ],
});
